module.exports = __webpack_public_path__ + "static/media/BauPro-Medium.7f7cfb4b.eot";